export const isApp = true



// WEBPACK FOOTER //
// ./C:/vue/2.0/src/common.js